import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  acceptCurrentLegal,
  type LegalAcceptanceSource,
} from '@/src/features/legal/legal-service';
import type { UserProfile } from '@/src/features/profile/profile-service';
import { profileQueryKey } from '@/src/features/profile/use-profile';
import { assert } from '@/src/utils/assert';

export function useAcceptCurrentLegal(uid: string | undefined) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      email,
      source,
    }: {
      email: string | null;
      source: LegalAcceptanceSource;
    }) => {
      assert(uid, 'User ID is required to accept legal terms.');
      return acceptCurrentLegal({ uid, email, source });
    },
    onSuccess: async (legal) => {
      queryClient.setQueryData<UserProfile | null>(
        profileQueryKey(uid),
        (profile) => (profile ? { ...profile, legal } : profile),
      );
      await queryClient.invalidateQueries({ queryKey: profileQueryKey(uid) });
    },
  });
}
